<template>
  <div>
    <div
      class="cropper-content"
      v-if="showPetInfoImgCropper"
    >
      <div class="cropper-box-content">
        <div class="cropper">
          <vue-cropper
            ref="cropper"
            :img="pwoption.img"
            :outputSize="pwoption.outputSize"
            :outputType="pwoption.outputType"
            :info="pwoption.info"
            :canScale="pwoption.canScale"
            :autoCrop="pwoption.autoCrop"
            :autoCropWidth="pwoption.autoCropWidth"
            :autoCropHeight="pwoption.autoCropHeight"
            :fixed="pwoption.fixed"
            :fixedNumber="pwoption.fixedNumber"
            :full="pwoption.full"
            :fixedBox="pwoption.fixedBox"
            :canMove="pwoption.canMove"
            :canMoveBox="pwoption.canMoveBox"
            :original="pwoption.original"
            :centerBox="pwoption.centerBox"
            :height="pwoption.height"
            :infoTrue="pwoption.infoTrue"
            :maxImgSize="pwoption.maxImgSize"
            :enlarge="pwoption.enlarge"
            :mode="pwoption.mode"
            @imgLoad="imgLoad"
          >
          </vue-cropper>
          <!--底部操作工具按钮-->
          <div class="footer-btn">
            <div
              class="scope-btn"
              v-if="showLocalImgButton"
            >
              <label
                class="btn"
                for="uploads"
              >
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M50 21V79.3333"
                    stroke="#999999"
                    stroke-width="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 50H79.3333"
                    stroke="#999999"
                    stroke-width="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </label>
              <input
                type="file"
                id="uploads"
                style="position:absolute; clip:rect(0 0 0 0);"
                accept="image/png, image/jpeg, image/jpg"
                @change="selectImg($event)"
              >
            </div>
            <div class="upload-btn">
              <div
                class="upload-btn-cancel"
                @click="clearCrop"
              >Cancel</div>
              <div
                v-if="!showLocalImgButton"
                class="upload-btn-confirm"
                @click="uploadImg('blob')"
              >Confirm</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-form
      :model="editPetData"
      :rules="rules"
      ref="editPetData"
      v-if="showOldVersions"
    >
      <el-tabs
        type="border-card"
        :before-leave="leaveTab"
        class="pw-info-content"
      >
        <el-tab-pane label="Pet's Information">
          <div class="pet-info-box">
            <img
              v-if="currentPetInfo.photo"
              v-show="showPetInfoImg"
              :src="'https://finder.pawaiipets.com' + currentPetInfo.photo"
              class="avatar avatar-uploader avatar-uploader-have"
            />
            <img
              v-else
              v-show="showPetInfoImg"
              src="https://finder.pawaiipets.com/static/blank.png"
              class="avatar avatar-uploader-have"
            />
            <div
              v-if="!showPetInfoImg"
              class="avatar-uploader"
              :headers="headers"
            >
              <img
                v-if="editPetData.photo"
                :src="'https://finder.pawaiipets.com' + editPetData.photo"
                class="avatar"
              />

              <img
                v-else
                class="el-icon-plus avatar-uploader-icon"
                src="https://finder.pawaiipets.com/static/blank.png"
                alt=""
              />
              <img
                class="avatar-edit"
                src="../../assets/img/info/avatar-edit.png"
                alt=""
                @click="handleClickshowCropper"
              />
            </div>
            <table>
              <tr>
                <td><span
                    class="required-red"
                    v-if="StarRed"
                  >* </span>Pet's Name</td>
                <td v-if="editPetState">{{ currentPetInfo.pet_name }}</td>
                <td v-if="!editPetState">
                  <el-form-item prop="pet_name">
                    <el-input
                      v-model="editPetData.pet_name"
                      v-focus
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td><span
                    class="required-red"
                    v-if="StarRed"
                  >* </span>Species</td>
                <td v-if="editPetState">
                  {{
                    currentPetInfo.species1 === "other"
                      ? currentPetInfo.species2
                      : currentPetInfo.species1
                  }}
                </td>
                <td
                  class="no-editPetState"
                  v-if="!editPetState"
                >
                  <el-select
                    v-model="editPetData.species1"
                    placeholder="Please select"
                    @change="selectPetSpecies"
                  >
                    <el-option
                      v-for="item in speciesData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-form-item
                    class="input-bottom-err"
                    prop="species2"
                    v-if="showSpeciesOtherInput"
                  >
                    <el-input
                      class="input-bottom"
                      v-model="editPetData.species2"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td><span
                    class="required-red"
                    v-if="StarRed"
                  >* </span>Breed</td>
                <td v-if="editPetState">
                  {{
                    currentPetInfo.breed1 === "Other" ||
                    currentPetInfo.species1 === "other"
                      ? currentPetInfo.breed2
                      : currentPetInfo.breed1 + " " + currentPetInfo.option 
                  }}
                </td>
                <td
                  class="no-editPetState"
                  v-if="!editPetState"
                >
                  <el-form-item
                    class="input-bottom-err"
                    prop="breed1"
                    v-if="showBreedOtherSelect"
                  >
                    <el-select
                      v-model="editPetData.breed1"
                      placeholder=""
                      @change="showPetBreedInput"
                      @visible-change="getAboutPetData"
                    >
                      <el-option
                        v-for="item in breedData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="input-bottom-err"
                    prop="breed2"
                    v-if="showBreedOtherInput"
                  >
                    <el-input
                      class="input-bottom"
                      v-model="editPetData.breed2"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td><span
                    class="required-red"
                    v-if="StarRed"
                  >* </span>Gender</td>
                <td v-if="editPetState">{{ gender }}</td>
                <td
                  class="no-editPetState"
                  v-if="!editPetState"
                >
                  <el-select
                    v-model="editPetData.gender"
                    placeholder="Please select"
                  >
                    <el-option
                      v-for="item in genderData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr class="editPetState-tr">
                <td><span
                    class="required-red"
                    v-if="StarRed"
                  >* </span>Age</td>
                <td v-if="editPetState">
                  {{ age === "undefined undefined" ? "" : age }}
                </td>
                <td
                  class="no-editPetState-age"
                  v-if="!editPetState"
                >
                  <div class="editPetState-tr-box">
                    <div>
                      <el-select
                        v-model="editPetData.age1"
                        placeholder="Please select"
                      >
                        <el-option
                          v-for="item in ageYearsData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        v-model="editPetData.age2"
                        placeholder="Please select"
                      >
                        <el-option
                          v-for="item in ageMonthData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </td>
                <!-- <td
                  class="no-editPetState-age-right"
                  v-if="!editPetState"
                >
                  
                </td> -->
              </tr>
              <tr>
                <td>Weight</td>
                <td v-if="editPetState">{{ currentPetInfo.weight }}</td>
                <td v-if="!editPetState">
                  <el-input
                    v-model="editPetData.weight"
                    placeholder="Enter your text"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>Eating Habits</td>
                <td v-if="editPetState">{{ currentPetInfo.habit }}</td>
                <td v-if="!editPetState">
                  <el-input
                    v-model="editPetData.habit"
                    placeholder="Enter your text"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>Allergic History</td>
                <td v-if="editPetState">{{ currentPetInfo.allergic }}</td>
                <td v-if="!editPetState">
                  <el-input
                    v-model="editPetData.allergic"
                    placeholder="Enter your text"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>Medical History</td>
                <td v-if="editPetState">{{ currentPetInfo.medical }}</td>
                <td v-if="!editPetState">
                  <el-input
                    v-model="editPetData.medical"
                    placeholder="Enter your text"
                  ></el-input>
                </td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Owner's Information">
          <table>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Full Name</td>
              <td v-if="editPetState">{{ currentPetInfo.own_name }}</td>
              <td v-if="!editPetState">
                <el-form-item prop="own_name">
                  <el-input
                    v-model="editPetData.own_name"
                    v-focus
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Phone</td>
              <td v-if="editPetState">
                {{ currentPetInfo.phone }}
              </td>
              <td v-if="!editPetState">
                <el-form-item prop="phone">
                  <el-input v-model="editPetData.phone"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Family Member</td>
              <td v-if="editPetState">
                {{ currentPetInfo.family_member }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-select
                  v-model="editPetData.family_member"
                  placeholder="Please select"
                >
                  <el-option
                    v-for="item in familyMemberData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Country/Region</td>
              <td v-if="editPetState">
                {{
                  currentPetInfo.country1 === "Other"
                    ? currentPetInfo.country2
                    : currentPetInfo.country1
                }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-select
                  v-model="editPetData.country1"
                  placeholder="Please select"
                  @change="ShowCountryInfo"
                >
                  <el-option
                    v-for="item in countryData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-form-item
                  class="input-bottom-err"
                  prop="country2"
                  v-if="otherCountryInput"
                >
                  <el-input
                    class="input-bottom"
                    v-model="editPetData.country2"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>

            <tr class="owner-edit-pad-more owner-edit-adress">
              <td>Address</td>
              <td
                v-if="editPetState"
                class="owner-edit-adress-noedit"
              >
                {{ address === "undefined undefined" ? "" : address }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  class="owner-edit-adress-input"
                  v-model="editPetData.address1"
                  placeholder="Street address or P.O. Box"
                ></el-input>
                <el-input
                  v-model="editPetData.address2"
                  placeholder="Apt, Suite, Unit, Building"
                ></el-input>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>City</td>
              <td v-if="editPetState">{{ currentPetInfo.city }}</td>
              <td v-if="!editPetState">
                <el-form-item prop="city">
                  <el-input v-model="editPetData.city"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>State</td>
              <td v-if="editPetState">
                {{
                  currentPetInfo.country1 === "Other"
                    ? currentPetInfo.state2
                    : currentPetInfo.state1
                }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-form-item
                  class="input-bottom-err"
                  prop="state1"
                  v-if="!otherCountryInput"
                >
                  <el-select
                    v-model="editPetData.state1"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in usaStateData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="input-bottom-err"
                  prop="state2"
                  v-if="otherCountryInput"
                >
                  <el-input
                    class="input-bottom"
                    v-model="editPetData.state2"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td>ZIP code</td>
              <td v-if="editPetState">
                {{
                  currentPetInfo.country1 === "Other"
                    ? currentPetInfo.zip2
                    : currentPetInfo.zip1
                }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  v-model="editPetData.zip1"
                  placeholder="Enter your text"
                  v-show="!otherCountryInput"
                ></el-input>
                <el-input
                  v-model="editPetData.zip2"
                  placeholder="Enter your text"
                  v-show="otherCountryInput"
                ></el-input>
              </td>
            </tr>
            <tr class="owner-edit-pad-message">
              <td>Message</td>
              <td
                class="long-text"
                v-if="editPetState"
              >
                {{ currentPetInfo.message }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  v-model="editPetData.message"
                  placeholder="Enter your text"
                ></el-input>
              </td>
            </tr>
          </table>
        </el-tab-pane>

        <!-- 操作按钮 -->
        <div class="paw-petinfo-content-btns">
          <el-button
            v-on:click="StarRed=true"
            class="btn btn-left paw-petinfo-content-btn-edit paw-petinfo-content-btn"
            v-if="editPetState"
            @click="editPetInfo"
          >Edit</el-button>
          <el-button
            class="btn btn-right paw-petinfo-content-btn-delete paw-petinfo-content-btn"
            v-if="editPetState"
            @click="deletePetInfo"
          >Delete</el-button>
          <el-row v-if="!editPetState">
            <el-button
              v-on:click="StarRed=false"
              class="btn btn-left paw-petinfo-content-btn paw-petinfo-content-btn-cancel"
              @click="editPetCandle"
            >Cancel</el-button>
            <el-button
              v-on:click="StarRed=false"
              type="primary"
              class="btn btn-right paw-petinfo-content-btn paw-petinfo-content-btn-save"
              @click="editPetSave"
              :class="{ btnactive: selected,}"
            >Save</el-button>
          </el-row>
        </div>
      </el-tabs>
    </el-form>
    <el-form
      class="pw-newedit-ui"
      :model="editPetData"
      :rules="rules"
      ref="editPetData"
      v-if="showNewVersions"
    >
      <el-tabs
        type="border-card"
        :before-leave="leaveTab"
      >
        <!-- <el-tab-pane> -->
        <div class="pet-info-box">
          <img
            v-if="currentPetInfo.photo"
            v-show="showPetInfoImg"
            :src="'https://finder.pawaiipets.com' + currentPetInfo.photo"
            class="avatar avatar-uploader avatar-uploader-have"
          />
          <img
            v-else
            v-show="showPetInfoImg"
            src="https://finder.pawaiipets.com/static/blank.png"
            class="avatar avatar-uploader-have"
          />
          <div
            v-if="!showPetInfoImg"
            class="avatar-uploader pw-editpetinfo-avater-uploader"
          >
            <img
              v-if="editPetData.photo"
              :src="'https://finder.pawaiipets.com' + editPetData.photo"
              class="avatar"
            />

            <img
              v-else
              class="el-icon-plus avatar-uploader-icon"
              src="https://finder.pawaiipets.com/static/blank.png"
              alt=""
            />
            <img
              class="avatar-edit"
              src="../../assets/img/info/avatar-edit.png"
              alt=""
              @click="handleClickshowCropper"
            />
          </div>
          <table class="paw-petinfo-content-table">
            <tr>
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Pet's Name</td>
              <td v-if="editPetState">{{ currentPetInfo.pet_name }}</td>
              <td v-if="!editPetState">
                <el-form-item prop="pet_name">
                  <el-input
                    v-model="editPetData.pet_name"
                    v-focus
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Species</td>
              <td v-if="editPetState">
                {{
                    currentPetInfo.species1 === "other"
                      ? currentPetInfo.species2
                      : currentPetInfo.species1
                  }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-select
                  v-model="editPetData.species1"
                  placeholder="Please select"
                  @change="selectPetSpecies"
                >
                  <el-option
                    v-for="item in speciesData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-form-item
                  class="input-bottom-err"
                  prop="species2"
                  v-if="showSpeciesOtherInput"
                >
                  <el-input
                    class="input-bottom"
                    v-model="editPetData.species2"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>



            <tr>
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Breed</td>
              <td v-if="editPetState">
                {{
                    currentPetInfo.breed1 === "Other" ||
                    currentPetInfo.species1 === "other"
                      ? currentPetInfo.breed2
                      : currentPetInfo.breed1 + " " + currentPetInfo.option 
                  }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-form-item
                  class="input-bottom-err"
                  prop="breed1"
                  v-if="showBreedOtherSelect"
                >

                  <el-select
                    v-model="editPetData.breed1"
                    placeholder=""
                    @visible-change="newgetAboutPetData"
                    @change="newShowPetinfoOptioninput"
                  >
                    <el-option
                      v-for="item in newbreedData"
                      :key="item.breed_us"
                      :label="item.breed_us"
                      :value="item.breed_us"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    v-model="editPetData.option"
                    placeholder=""
                    v-if="newShowPetinfoOption"
                  >
                    <el-option
                      v-for="item in newPetinfoOption"
                      :key="item.option_us"
                      :label="item.option_us"
                      :value="item.option_us"
                    >
                    </el-option>
                  </el-select>

                </el-form-item>
                <el-form-item
                  class="input-bottom-err"
                  prop="breed2"
                  v-if="showBreedOtherInput"
                >
                  <el-input
                    class="input-bottom"
                    v-model="editPetData.breed2"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>




            <tr class="owner-edit-pad owner-edit-pad-birthday ">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Birthday</td>
              <td v-if="editPetState">
                {{showeditPetDataBirthday}}
              </td>
              <td
                v-if="!editPetState"
                class="pw-editpetinfo-birthday"
              >
                <el-date-picker
                  class="pw-petinfo-birthday"
                  prop="birthday"
                  :editable="false"
                  v-model="editPetData.birthday"
                  type="date"
                  @change="onPetinfoBirthday"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="Please choose a birthday"
                >
                </el-date-picker>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td><span
                  class="required-red"
                  v-if="StarRed"
                >* </span>Phone</td>
              <td v-if="editPetState">
                {{ currentPetInfo.phone }}
              </td>
              <td v-if="!editPetState">
                <el-form-item prop="phone">
                  <el-input v-model="editPetData.phone"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>Weight</td>
              <td v-if="editPetState">{{ currentPetInfo.weight === "" ? currentPetInfo.weight : weight_show }}</td>
              <!-- <td v-if="editPetState">{{ currentPetInfo.weight }}</td> -->
              <td v-if="!editPetState">
                <el-input
                  class="pw-petinfo-weight-input"
                  v-model="editPetData.weight"
                  placeholder="Enter your text"
                ></el-input>
                <el-select
                  class="pw-petinfo-weight-select"
                  v-model="editPetData.unit"
                >
                  <el-option
                    v-for="item in optionsselect"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td>Country/Region</td>
              <td v-if="editPetState">
                {{currentPetInfo.country1}}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-select
                  v-model="editPetData.country1"
                  placeholder="Please select"
                  @change="ShowCountryInfo"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.country"
                    :value="item.country"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr class="owner-edit-pad-more owner-edit-adress">
              <td>Address</td>
              <td
                v-if="editPetState"
                class="owner-edit-adress-noedit"
              >
                {{ address === "undefined undefined" ? "" : address }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  class="owner-edit-adress-input"
                  v-model="editPetData.address1"
                  placeholder="Street address or P.O. Box"
                ></el-input>
                <el-input
                  v-model="editPetData.address2"
                  placeholder="Apt, Suite, Unit, Building"
                ></el-input>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td>City</td>
              <td v-if="editPetState">{{ currentPetInfo.city }}</td>
              <td v-if="!editPetState">
                <el-form-item>
                  <el-input v-model="editPetData.city"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td>State</td>
              <td v-if="editPetState">
                {{
                  currentPetInfo.country1 === "United States"
                    ? currentPetInfo.state1
                    : currentPetInfo.state2
                }}
              </td>
              <td
                class="no-editPetState"
                v-if="!editPetState"
              >
                <el-form-item
                  class="input-bottom-err"
                  v-if="!otherCountryInput"
                >
                  <el-select
                    v-model="editPetData.state1"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in usaStateData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="input-bottom-err"
                  v-if="otherCountryInput"
                >
                  <el-input
                    class="input-bottom"
                    v-model="editPetData.state2"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr class="owner-edit-pad">
              <td>ZIP code</td>
              <td v-if="editPetState">
                {{
                  currentPetInfo.country1 !== "United States"
                    ? currentPetInfo.zip2
                    : currentPetInfo.zip1
                }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  v-model="editPetData.zip1"
                  placeholder="Enter your text"
                  v-show="!otherCountryInput"
                ></el-input>
                <el-input
                  v-model="editPetData.zip2"
                  placeholder="Enter your text"
                  v-show="otherCountryInput"
                ></el-input>
              </td>
            </tr>
            <tr class="owner-edit-pad-message">
              <td>Message</td>
              <td
                class="long-text"
                v-if="editPetState"
              >
                {{ currentPetInfo.message }}
              </td>
              <td v-if="!editPetState">
                <el-input
                  v-model="editPetData.message"
                  placeholder="Enter your text"
                ></el-input>
              </td>
            </tr>

          </table>
        </div>
        <!-- </el-tab-pane> -->

        <!-- 操作按钮 -->
        <div class="paw-petinfo-content-btns">
          <el-button
            v-on:click="StarRed=true"
            class="btn btn-left paw-petinfo-content-btn-edit paw-petinfo-content-btn"
            v-if="editPetState"
            @click="editPetInfo"
          >Edit</el-button>
          <el-button
            class="btn btn-right paw-petinfo-content-btn-delete paw-petinfo-content-btn"
            v-if="editPetState"
            @click="deletePetInfo"
          >Delete</el-button>
          <el-row v-if="!editPetState">
            <el-button
              v-on:click="StarRed=false"
              class="btn btn-left paw-petinfo-content-btn paw-petinfo-content-btn-cancel"
              @click="editPetCandle"
            >Cancel</el-button>
            <el-button
              type="primary"
              class="btn btn-right paw-petinfo-content-btn paw-petinfo-content-btn-save"
              @click="editPetSave"
              :class="{ btnactive: selected,}"
            >Save</el-button>
          </el-row>
        </div>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {

      //体重选择
      optionsselect: [
        {
          value: "Kg",
          label: "Kg",
        },
        {
          value: "Lb",
          label: "Lb",
        },
      ],
      // 显示版本判断
      showOldVersions: true,
      showNewVersions: false,
      // 裁剪框插件展示
      showPetInfoImgCropper: false,
      // 本地上传图片按钮展示
      showLocalImgButton: false,
      // 裁剪框数据
      previews: {},
      pwoption: {
        img: "", //裁剪图片的地址
        outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: "jpeg", //裁剪生成图片的格式（jpeg || png || webp）
        info: true, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 500, //默认生成截图框宽度
        autoCropHeight: 500, //默认生成截图框高度
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [1, 1], //截图框的宽高比例
        full: false, //false按原比例裁切图片，不失真
        fixedBox: true, //固定截图框大小，不允许改变
        canMove: false, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: true, //截图框是否被限制在图片里面
        height: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 2000, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "500px 500px", //图片默认渲染方式
      },

      // 图片上传携带token
      headers: {
        Authorization: window.sessionStorage.getItem("token"),
      },
      // 图片回显地址
      petUrl: "",
      // 控制图片展示与上传显示
      showPetInfoImg: true,
      // 修改宠物的表单数据
      editPetData: {},
      rules: {
        pet_name: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        breed1: [
          { required: true, message: "Please select", trigger: "change" },
          { required: true, message: "Please select", trigger: "blur" },
        ],
        breed2: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        state1: [
          { required: true, message: "Please select", trigger: "change" },
          { required: true, message: "Please select", trigger: "blur" },
        ],
        state2: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        species2: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        own_name: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        country2: [
          { required: true, message: "Enter your text", trigger: "change" },
          { required: true, message: "Enter your text", trigger: "blur" },
        ],
        city: [
          { required: true, message: "Please select", trigger: "change" },
          { required: true, message: "Please select", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "Please select", trigger: "change" },
          { required: true, message: "Please select", trigger: "blur" },
        ],
      },
      // species选择框相关数据
      speciesData: [
        {
          value: "dog",
          label: "Dog",
        },
        {
          value: "cat",
          label: "Cat",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      // bredd-dog数据
      breedDogData: [
        {
          value: "Non-pedigree",
          label: "Non-pedigree",
        },
        {
          value: "Retrievers (Labrador)",
          label: "Retrievers (Labrador)",
        },
        {
          value: "German Shepherd Dogs",
          label: "German Shepherd Dogs",
        },
        {
          value: "Retrievers (Golden)",
          label: "Retrievers (Golden)",
        },
        {
          value: "French Bulldogs",
          label: "French Bulldogs",
        },
        {
          value: "Bulldogs",
          label: "Bulldogs",
        },
        {
          value: "Poodles",
          label: "Poodles",
        },
        {
          value: "Beagles",
          label: "Beagles",
        },
        {
          value: "Rottweilers",
          label: "Rottweilers",
        },
        {
          value: "Pointers (German Shorthaired)",
          label: "Pointers (German Shorthaired)",
        },
        {
          value: "Pembroke Welsh Corgis",
          label: "Pembroke Welsh Corgis",
        },
        {
          value: "Dachshunds",
          label: "Dachshunds",
        },
        {
          value: "Yorkshire Terriers",
          label: "Yorkshire Terriers",
        },
        {
          value: "Australian Shepherds",
          label: "Australian Shepherds",
        },
        {
          value: "Boxers",
          label: "Boxers",
        },
        {
          value: "Siberian Huskies",
          label: "Siberian Huskies",
        },
        {
          value: "Cavalier King Charles Spaniels",
          label: "Cavalier King Charles Spaniels",
        },
        {
          value: "Great Danes",
          label: "Great Danes",
        },
        {
          value: "Miniature Schnauzers",
          label: "Miniature Schnauzers",
        },
        {
          value: "Doberman Pinschers",
          label: "Doberman Pinschers",
        },
        {
          value: "Shih Tzu",
          label: "Shih Tzu",
        },
        {
          value: "Boston Terriers",
          label: "Boston Terriers",
        },
        {
          value: "Havanese",
          label: "Havanese",
        },
        {
          value: "Bernese Mountain Dogs",
          label: "Bernese Mountain Dogs",
        },
        {
          value: "Pomeranians",
          label: "Pomeranians",
        },
        {
          value: "Shetland Sheepdogs",
          label: "Shetland Sheepdogs",
        },
        {
          value: "Brittanys",
          label: "Brittanys",
        },
        {
          value: "Spaniels (English Springer)",
          label: "Spaniels (English Springer)",
        },
        {
          value: "Spaniels (Cocker)",
          label: "Spaniels (Cocker)",
        },
        {
          value: "Miniature American Shepherds",
          label: "Miniature American Shepherds",
        },
        {
          value: "Cane Corso",
          label: "Cane Corso",
        },
        {
          value: "Pugs",
          label: "Pugs",
        },
        {
          value: "Mastiffs",
          label: "Mastiffs",
        },
        {
          value: "Border Collies",
          label: "Border Collies",
        },
        {
          value: "Vizslas",
          label: "Vizslas",
        },
        {
          value: "Chihuahuas",
          label: "Chihuahuas",
        },
        {
          value: "Maltese",
          label: "Maltese",
        },
        {
          value: "Basset Hounds",
          label: "Basset Hounds",
        },
        {
          value: "Collies",
          label: "Collies",
        },
        {
          value: "Weimaraners",
          label: "Weimaraners",
        },
        {
          value: "Newfoundlands",
          label: "Newfoundlands",
        },
        {
          value: "Belgian Malinois",
          label: "Belgian Malinois",
        },
        {
          value: "Rhodesian Ridgebacks",
          label: "Rhodesian Ridgebacks",
        },
        {
          value: "Bichons Frises",
          label: "Bichons Frises",
        },
        {
          value: "West Highland White Terriers",
          label: "West Highland White Terriers",
        },
        {
          value: "Shiba Inu",
          label: "Shiba Inu",
        },
        {
          value: "Retrievers (Chesapeake Bay)",
          label: "Retrievers (Chesapeake Bay)",
        },
        {
          value: "Akitas",
          label: "Akitas",
        },
        {
          value: "St. Bernards",
          label: "St. Bernards",
        },
        {
          value: "Portuguese Water Dogs",
          label: "Portuguese Water Dogs",
        },
        {
          value: "Spaniels (English Cocker)",
          label: "Spaniels (English Cocker)",
        },
        {
          value: "Other",
          label: "Other",
        },
      ],
      // bredd-cat数据
      breedCatData: [
        {
          value: "Non-pedigree",
          label: "Non-pedigree",
        },
        {
          value: "Abyssinian",
          label: "Abyssinian",
        },
        {
          value: "American Shorthair",
          label: "American Shorthair",
        },
        {
          value: "Bengal",
          label: "Bengal",
        },
        {
          value: "Birman",
          label: "Birman",
        },
        {
          value: "Bombay",
          label: "Bombay",
        },
        {
          value: "British Shorthair",
          label: "British Shorthair",
        },
        {
          value: "Burmilla",
          label: "Burmilla",
        },
        {
          value: "Chartreux",
          label: "Chartreux",
        },
        {
          value: "Devon Rex",
          label: "Devon Rex",
        },
        {
          value: "Exotic Shorthair",
          label: "Exotic Shorthair",
        },
        {
          value: "Himalayan",
          label: "Himalayan",
        },
        {
          value: "Maine Coon",
          label: "Maine Coon",
        },
        {
          value: "Nebelung",
          label: "Nebelung",
        },
        {
          value: "Norwegian Forest",
          label: "Norwegian Forest",
        },
        {
          value: "Oriental Shorthair",
          label: "Oriental Shorthair",
        },
        {
          value: "Persian",
          label: "Persian",
        },
        {
          value: "Ragamuffin",
          label: "Ragamuffin",
        },
        {
          value: "Ragdoll",
          label: "Ragdoll",
        },
        {
          value: "Russian Blue",
          label: "Russian Blue",
        },
        {
          value: "Scottish Fold",
          label: "Scottish Fold",
        },
        {
          value: "Siamese",
          label: "Siamese",
        },
        {
          value: "Siberian",
          label: "Siberian",
        },
        {
          value: "Snowshoe cat",
          label: "Snowshoe cat",
        },
        {
          value: "Sphynx",
          label: "Sphynx",
        },
        {
          value: "Tonkinese",
          label: "Tonkinese",
        },
        {
          value: "Turkish Angora",
          label: "Turkish Angora",
        },
        {
          value: "Turkish Van",
          label: "Turkish Van",
        },
        {
          value: "Other",
          label: "Other",
        },
      ],
      // 由species决定的bredd数据
      breedData: [],
      // 新版由species决定的bredd数据
      newbreedData: [],
      // 新版breed下分类展示判断
      newShowPetinfoOption: false,
      // other选项控制species input框展示
      showSpeciesOtherInput: "",
      // other选项控制breed 选择框、input框展示
      showBreedOtherSelect: "",
      showBreedOtherInput: "",
      // 新版breed下拉分类多级选项
      newPetinfoOption: [],
      // gender数据
      genderData: [
        {
          value: 1,
          label: "Male",
        },
        {
          value: 2,
          label: "Female",
        },
        {
          value: 3,
          label: "No answer",
        },
      ],
      // age years数据
      ageYearsData: [
        {
          value: "0 Years",
          label: "0 Years",
        },
        {
          value: "1 Year",
          label: "1 Year",
        },
        {
          value: "2 Year",
          label: "2 Year",
        },
        {
          value: "3 Years",
          label: "3 Years",
        },
        {
          value: "4 Years",
          label: "4 Years",
        },
        {
          value: "5 Years",
          label: "5 Years",
        },
        {
          value: "6 Years",
          label: "6 Years",
        },
        {
          value: "7 Years",
          label: "7 Years",
        },
        {
          value: "8 Years",
          label: "8 Years",
        },
        {
          value: "9 Years",
          label: "9 Years",
        },
        {
          value: "10 Years",
          label: "10 Years",
        },
        {
          value: "11 Years",
          label: "11 Years",
        },
        {
          value: "12 Years",
          label: "12 Years",
        },
        {
          value: "13 Years",
          label: "13 Years",
        },
        {
          value: "14 Years",
          label: "14 Years",
        },

        {
          value: "15 Years",
          label: "15 Years",
        },
        {
          value: "16 Years",
          label: "16 Years",
        },
        {
          value: "17 Years",
          label: "17 Years",
        },

        {
          value: "18 Years",
          label: "18 Years",
        },
        {
          value: "19 Years",
          label: "19 Years",
        },
        {
          value: "20 Years",
          label: "20 Years",
        },
        {
          value: "21 Years",
          label: "21 Years",
        },
        {
          value: "22 Years",
          label: "22 Years",
        },
        {
          value: "23 Years",
          label: "23 Years",
        },
        {
          value: "24 Years",
          label: "24 Years",
        },
        {
          value: "25 Years",
          label: "25 Years",
        },
        {
          value: "26 Years",
          label: "26 Years",
        },
        {
          value: "27 Years",
          label: "27 Years",
        },
        {
          value: "28 Years",
          label: "28 Years",
        },
        {
          value: "29 Years",
          label: "29 Years",
        },
        {
          value: "30 Years",
          label: "30 Years",
        },
        {
          value: "31 Years",
          label: "31 Years",
        },
      ],
      // age month数据
      ageMonthData: [
        {
          value: "0 Months",
          label: "0 Months",
        },
        {
          value: "1 Month",
          label: "1 Month",
        },
        {
          value: "2 Months",
          label: "2 Months",
        },
        {
          value: "3 Months",
          label: "3 Months",
        },
        {
          value: "4 Months",
          label: "4 Months",
        },
        {
          value: "5 Months",
          label: "5 Months",
        },
        {
          value: "6 Months",
          label: "6 Months",
        },
        {
          value: "7 Months",
          label: "7 Months",
        },
        {
          value: "8 Months",
          label: "8 Months",
        },
        {
          value: "9 Months",
          label: "9 Months",
        },
        {
          value: "10 Months",
          label: "10 Months",
        },
        {
          value: "11 Months",
          label: "11 Months",
        },
        {
          value: "12 Months",
          label: "12 Months",
        },
      ],
      // buy type数据
      buyTypeData: [
        {
          value: "Harness",
          label: "Harness",
        },
        {
          value: "Collar",
          label: "Collar",
        },
      ],
      // Family Member数据
      familyMemberData: [
        {
          value: "Dad",
          label: "Dad",
        },
        {
          value: "Mom",
          label: "Mom",
        },
        {
          value: "Brother",
          label: "Brother",
        },
        {
          value: "Sister",
          label: "Sister",
        },
      ],
      // country数据
      countryData: [
        {
          value: "United States",
          label: "United States",
        },
        {
          value: "Other",
          label: "Other countries and regions",
        },
      ],
      otherCountryInput: "",
      // usa state数据
      usaStateData: [
        {
          value: "Washington District of Columbia",
          label: "Washington District of Columbia",
        },
        {
          value: "Alabama",
          label: "Alabama",
        },
        {
          value: "Alaska",
          label: "Alaska",
        },
        {
          value: "Arizona",
          label: "Arizona",
        },
        {
          value: "Arkansas",
          label: "Arkansas",
        },
        {
          value: "California",
          label: "California",
        },
        {
          value: "Colorado",
          label: "Colorado",
        },
        {
          value: "Connecticut",
          label: "Connecticut",
        },
        {
          value: "Delaware",
          label: "Delaware",
        },
        {
          value: "Florida",
          label: "Florida",
        },
        {
          value: "Georgia",
          label: "Georgia",
        },
        {
          value: "Hawaii",
          label: "Hawaii",
        },
        {
          value: "Idaho",
          label: "Idaho",
        },
        {
          value: "Illinois",
          label: "Illinois",
        },
        {
          value: "Indiana",
          label: "Indiana",
        },
        {
          value: "Iowa",
          label: "Iowa",
        },
        {
          value: "Kansas",
          label: "Kansas",
        },
        {
          value: "Kentucky",
          label: "Kentucky",
        },
        {
          value: "Louisiana",
          label: "Louisiana",
        },
        {
          value: "Maine",
          label: "Maine",
        },
        {
          value: "Maryland",
          label: "Maryland",
        },
        {
          value: "Massachusetts",
          label: "Massachusetts",
        },
        {
          value: "Michigan",
          label: "Michigan",
        },
        {
          value: "Minnesota",
          label: "Minnesota",
        },
        {
          value: "Mississippi",
          label: "Mississippi",
        },
        {
          value: "Missouri",
          label: "Missouri",
        },
        {
          value: "Montana",
          label: "Montana",
        },
        {
          value: "Nebraska",
          label: "Nebraska",
        },
        {
          value: "Nevada",
          label: "Nevada",
        },
        {
          value: "New Hampshire",
          label: "New Hampshire",
        },
        {
          value: "New Jersey",
          label: "New Jersey",
        },
        {
          value: "New Mexico",
          label: "New Mexico",
        },
        {
          value: "New York",
          label: "New York",
        },
        {
          value: "North Carolina",
          label: "North Carolina",
        },
        {
          value: "North Dakota",
          label: "North Dakota",
        },
        {
          value: "Ohio",
          label: "Ohio",
        },
        {
          value: "Oklahoma",
          label: "Oklahoma",
        },
        {
          value: "Oregon",
          label: "Oregon",
        },
        {
          value: "Pennsylvania",
          label: "Pennsylvania",
        },
        {
          value: "Rhode Island",
          label: "Rhode Island",
        },
        {
          value: "South Carolina",
          label: "South Carolina",
        },
        {
          value: "South Dakota",
          label: "South Dakota",
        },

        {
          value: "Tennessee",
          label: "Tennessee",
        },
        {
          value: "Texas",
          label: "Texas",
        },
        {
          value: "Utah",
          label: "Utah",
        },
        {
          value: "Vermont",
          label: "Vermont",
        },
        {
          value: "Virginia",
          label: "Virginia",
        },
        {
          value: "Washington",
          label: "Washington",
        },
        {
          value: "West Virginia",
          label: "West Virginia",
        },
        {
          value: "Wisconsin",
          label: "Wisconsin",
        },
        {
          value: "Wyoming",
          label: "Wyoming",
        },
        {
          value: "American Samoa",
          label: "American Samoa",
        },
        {
          value: "Guam",
          label: "Guam",
        },
        {
          value: "Puerto Rico",
          label: "Puerto Rico",
        },
        {
          value: "Northern Marianas",
          label: "Northern Marianas",
        },
        {
          value: "U.S. Virgin Islands",
          label: "U.S. Virgin Islands",
        },
      ],
      // 必填项星号
      StarRed: false,
    };
  },

  // 局部自定义指令，让首个input框一直获得焦点
  directives: {
    focus: {
      inserted(element) {
        element.children[0].focus();
      },
    },
  },
  // 父组件当前点击的宠物数据
  props: ["currentPetInfo", "countryList", "petsBreeds"],
  computed: {
    ...mapState("pcPetStore", ["editPetState"]),
    // 处理返回的性别数据
    gender() {
      return this.currentPetInfo.gender === 1
        ? "Male"
        : "" || this.currentPetInfo.gender === 2
        ? "Female"
        : "" || this.currentPetInfo.gender === 3
        ? "No answer"
        : "";
    },
    // 处理返回的年龄数据
    age() {
      return this.currentPetInfo.age1 + " " + this.currentPetInfo.age2;
    },
    // 处理返回的地址
    address() {
      return this.currentPetInfo.address1 + " " + this.currentPetInfo.address2;
    },
    // 处理返回的体重
    weight_show() {
      return this.currentPetInfo.weight + " " + this.currentPetInfo.unit;
    },

    // 处理展示数据
    showeditPetDataBirthday() {
      return this.currentPetInfo.birthday == null
        ? ""
        : this.currentPetInfo.birthday.split(" ")[0];
    },
  },
  beforeUpdate() {
    if (this.currentPetInfo.old_code == 1) {
      this.showNewVersions = false;
      this.showOldVersions = true;
    } else {
      this.showNewVersions = true;
      this.showOldVersions = false;
    }
  },
  methods: {
    // 修改操作
    editPetInfo() {
      //修改按钮颜色
      this.selected = true;
      // 改变editPetState值
      this.$store.commit("pcPetStore/changePetState");
      // 为了不影响父组件中的数据，复制一份父组件传来的数据给子组件中的editPetData
      this.editPetData = JSON.parse(JSON.stringify(this.currentPetInfo));
      // 控制点击
      this.$store.commit("pcPetStore/changeclickFlag");
      // 展示upload组件
      this.showPetInfoImg = false;
      // 宠物选择框初始值判断input显示
      if (this.editPetData.species1 === "other") {
        this.showSpeciesOtherInput = true;
        this.showBreedOtherInput = true;
        this.showBreedOtherSelect = false;
      }

      if (
        this.editPetData.species1 !== "other" &&
        this.editPetData.breed1 === "Other"
      ) {
        this.showSpeciesOtherInput = false;
        this.showBreedOtherInput = true;
        this.showBreedOtherSelect = true;
      }

      if (
        this.editPetData.species1 !== "other" &&
        this.editPetData.breed1 !== "Other"
      ) {
        this.showSpeciesOtherInput = false;
        this.showBreedOtherInput = false;
        this.showBreedOtherSelect = true;
      }
      // 主人选择框初始值判断input显示
      if (
        this.currentPetInfo.country1 === "Other" ||
        this.currentPetInfo.country1 !== "United States"
      ) {
        this.otherCountryInput = true;
      } else {
        this.otherCountryInput = false;
      }
      if (this.editPetData.option == "") {
        this.newShowPetinfoOption = false;
      } else {
        this.newShowPetinfoOption = true;
      }
      // newbreedData
      var editclickSpecies = this.editPetData.species1;
      if (editclickSpecies === "dog") {
        this.newbreedData = this.petsBreeds.dog;
      }
      if (editclickSpecies === "cat") {
        this.newbreedData = this.petsBreeds.cat;
      }
      for (let i = 0; i < this.newbreedData.length; i++) {
        if (this.newbreedData[i].breed_us == this.editPetData.breed1) {
          if (this.newbreedData[i].option == null) {
            this.newShowPetinfoOption = false;
          } else {
            this.newShowPetinfoOption = true;
            this.newPetinfoOption = this.newbreedData[i].option;
          }
        }
      }
    },
    // 删除操作
    async deletePetInfo() {
      // 为了不影响父组件中的数据，复制一份父组件传来的数据给子组件中的editPetData
      this.editPetData = JSON.parse(JSON.stringify(this.currentPetInfo));
      const confirmRes = await this.$confirm(
        "Deleting the information will not be restored and the digital ID tag will be reset. Scan the code and refill the information to activate the digital ID tag again. ",
        // "提示",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).catch((e) => e);
      if (confirmRes === "confirm") {
        const { data: res } = await this.$http.put("/clear", {
          id: this.editPetData.id,
        });
        if (res.status !== 200) return this.$message.error("Failed to delete");
        this.$message.success("Deleted");
        // 调用父组件事件，重新刷新宠物列表信息
        this.$emit("getPetInfo");
      } else {
        this.$message.info("Deletion request is cancelled");
      }
    },
    // 关闭操作
    editPetCandle() {
      this.selected = false;
      this.$store.commit("pcPetStore/changePetState");
      this.$store.commit("pcPetStore/changeclickFlag");
      this.showPetInfoImg = true;
      // 初始化其他选项input框的展示
      this.showBreedOtherSelect = "";
      this.showBreedOtherInput = "";
      this.showSpeciesOtherInput = "";
      this.otherCountryInput = "";
    },
    // 保存操作
    editPetSave() {
      this.$refs.editPetData.validate(async (valid) => {
        if (!valid) {
          this.selected = true;
          this.StarRed = true;
          return;
        }

        const { data: res } = await this.$http.put("/pet", this.editPetData);

        if (res.status !== 200) return this.$message.error("Failed to save");
        this.$message.success("Saved");
        this.$store.commit("pcPetStore/changePetState");
        this.$store.commit("pcPetStore/changeclickFlag");
        this.showPetInfoImg = true;
        this.selected = false;
        this.StarRed = false;

        this.$emit("getPetInfo", this.editPetData);
      });
    },
    // 表单未更改进行离开时提示
    leaveTab() {
      if (!this.editPetState) {
        this.$message({
          type: "warning",
          message: "Switch the page after you saved the infomation",
        });
        return false;
      }
    },
    // 上传图片展示裁剪框
    handleClickshowCropper() {
      this.showPetInfoImgCropper = true;
      this.showLocalImgButton = true;
    },
    // // 文件上传成功的回调
    // handleAvatarSuccess(response) {
    //   this.editPetData.photo = response.url;
    // },
    // // 文件上传之前的回调
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    //   if (!isJPG) {
    //     this.$message.error("Only JPG. PNG. file types are allowed");
    //   }
    //   return isJPG && isJPG;
    // },
    // 选择宠物种类
    selectPetSpecies(value) {
      if (value === "dog") {
        this.showSpeciesOtherInput = false;
        this.showBreedOtherSelect = true;
        this.showBreedOtherInput = false;
        this.breedData = this.breedDogData;
        this.editPetData.breed1 = "";
        this.editPetData.breed2 = "";
        this.editPetData.species2 = "";
        this.newShowPetinfoOption = false;
      }
      if (value === "cat") {
        this.showSpeciesOtherInput = false;
        this.showBreedOtherSelect = true;
        this.showBreedOtherInput = false;
        this.breedData = this.breedCatData;
        this.editPetData.breed1 = "";
        this.editPetData.breed2 = "";
        this.editPetData.species2 = "";
        this.newShowPetinfoOption = false;
      }
      if (value === "other") {
        this.showSpeciesOtherInput = true;
        this.showBreedOtherInput = true;
        this.showBreedOtherSelect = false;
        this.editPetData.breed1 = "";
        this.editPetData.breed2 = "";
        this.editPetData.species2 = "";
        this.newShowPetinfoOption = false;
      }
      this.$nextTick(() => {
        this.$refs.editPetData.clearValidate();
      });
    },
    getAboutPetData() {
      if (this.editPetData.species1 === "dog") {
        this.breedData = this.breedDogData;
      }
      if (this.editPetData.species1 === "cat") {
        this.breedData = this.breedCatData;
      }
    },
    newgetAboutPetData() {
      if (this.editPetData.species1 === "dog") {
        this.newbreedData = this.petsBreeds.dog;
      }
      if (this.editPetData.species1 === "cat") {
        this.newbreedData = this.petsBreeds.cat;
      }
    },

    //判断breed多级分类是否展示
    newShowPetinfoOptioninput(item) {
      this.editPetData.option = "";
      this.editPetData.breed2 = "";
      for (let i = 0; i < this.newbreedData.length; i++) {
        if (this.newbreedData[i].breed_us == item) {
          if (this.newbreedData[i].option == null) {
            this.newShowPetinfoOption = false;
          } else {
            this.newShowPetinfoOption = true;
            this.newPetinfoOption = this.newbreedData[i].option;
          }
        }
      }
    },

    // 宠物breed input框展示
    showPetBreedInput(value) {
      if (value === "Other") {
        this.showBreedOtherInput = true;
      } else {
        this.showBreedOtherInput = false;
      }
    },

    // country信息展示
    ShowCountryInfo(value) {
      if (value === "United States") {
        this.otherCountryInput = false;
        this.editPetData.country2 = "";
        this.editPetData.state1 = "";
        this.editPetData.state2 = "";
      } else {
        this.otherCountryInput = true;
        this.editPetData.country2 = "";
        this.editPetData.state1 = "";
        this.editPetData.state2 = "";
      }
    },
    // 修改生日
    onPetinfoBirthday(value) {
      this.editPetData.birthday = value;
    },

    //初始化函数
    imgLoad() {},
    //选择图片
    selectImg(e) {
      let file = e.target.files[0];
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: "Only JPG. PNG. file types are allowed",
          type: "error",
        });
        this.showLocalImgButton = true;
        return false;
      } else {
        this.showLocalImgButton = false;
      }
      //转化为blob
      let reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.pwoption.img = data;
      };
      //转化为base64
      reader.readAsDataURL(file);
    },
    //上传图片
    uploadImg(type) {
      let _this = this;
      if (type === "blob") {
        //获取截图的blob数据
        this.$refs.cropper.getCropBlob(async (data) => {
          let formData = new FormData();
          formData.append("file", data, "image.jpg");
          let { data: res } = await _this.$http.post("/upload", formData);
          if (res.status === 200) {
            _this.$message({
              message: "success",
              type: "success",
            });
            this.editPetData.photo = res.url;
            _this.$emit("uploadImgSuccess", res);
          } else {
            _this.$message({
              message: "error",
              type: "error",
            });
          }
          (this.showPetInfoImgCropper = false),
            (this.showLocalImgButton = false);
        });
      }
    },
    //清除动画
    clearCrop() {
      this.$refs.cropper.clearCrop();
      (this.pwoption.img = ""),
        (this.showPetInfoImgCropper = false),
        (this.showLocalImgButton = false);
    },
  },
};
</script>

<style scoped>
.required-red {
  color: red;
}
.long-text {
  overflow: hidden;
}
.el-tabs >>> .el-tabs__nav {
  width: 100%;
  background-color: #fff;
}
.el-tabs >>> .el-tabs__item {
  font-family: Poppins-Regular;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  color: #000000 !important;
  padding-left: 7px !important;
  padding-right: 7px !important;
  background-color: #fff;
  border-right: none !important;
  border-left: none !important;
  height: 30px;
}

.el-tabs >>> .is-active {
  border-bottom: 2px solid #ff5349 !important;
  border-right: none !important;
  border-left: none !important;
}
table {
  empty-cells: show;
  border-collapse: collapse;
  width: 100%;
}
table tr {
  border: 0.5px solid #e5e5e5;
  height: 40px;
}
table tr >>> td {
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  font-family: Poppins-Regular;
}
table tr >>> td:nth-child(1) {
  height: 41px;
  background-color: #f7f8f8;
  width: 150px;
  padding-left: 10.38px;
  color: #999999;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
table tr td:nth-child(2) {
  box-sizing: border-box;
  max-width: 510px;
  padding: 0 0 0 11px;
  color: #1a1a1a;
  word-wrap: break-word;
}
table >>> input {
  border: none;
  border-radius: 0;
  padding-left: 0;
  box-sizing: border-box;
  color: #1a1a1a;
}
.no-editPetState {
  background-color: #f7f8f8;
  padding: 0px !important;
}
.no-editPetState .el-select {
  width: 100%;
  max-width: 100%;
}
.no-editPetState >>> input {
  width: 509px;
  background-color: #f7f8f8;
  padding-left: 11px;
}
.no-editPetState >>> .input-bottom input {
  background-color: #fff;
}
.editPetState-tr {
  position: relative;
}
.editPetState-tr-box {
  display: flex;
}
.no-editPetState-age {
  background: #f7f8f8;
}
.no-editPetState-age >>> input {
  background: #f7f8f8;
}
.no-editPetState-age div {
  width: 100%;
  border-right: 0.5px solid #e5e5e5;
}
.no-editPetState-age div:last-child {
  border: none;
}
.no-editPetState-age {
  padding: 0 !important;
}
.editPetState-tr-box div {
  padding-left: 13px;
}
.editPetState-tr-box div .el-select {
  padding: 0;
}
/* .no-editPetState-age-right {
  position: absolute;
  right: 0;
  top: -1px;
}
.no-editPetState-age-right >>> input {
  background-color: #f7f8f8;
  width: 253px;
  border-left: 1px solid #e5e5e5 !important;
  padding-left: 11px;
  height: 39px;
}
.no-editPetState-age-left {
  background-color: #f7f8f8;
}
.no-editPetState-age-left >>> input {
  background-color: #f7f8f8;
  width: 250px;
} */
table >>> .el-input__suffix {
  right: 8px;
}
.no-editPetState-age-right >>> .el-input__suffix {
  right: 3.5px;
}
.owner-message td {
  height: 80px;
}
.owner-message td {
  height: 80px;
}
.el-tabs--border-card {
  border: none;
  box-shadow: none;
  position: relative;
}
.btn {
  background-color: #fff;
  border: 1px solid #c4c4c4;
  width: 100px;
  height: 36px;
  border-radius: 0;
  position: absolute;
  font-size: 15px;
  font-weight: 400;
  font-family: Poppins-Regular;
  color: #000000;
  display: grid;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.btn.btnactive {
  border-color: #ff5349;
  color: #ff5349;
}
.btn-left {
  padding: 0;
  left: 200px;
  bottom: 0px;
}
.btn-right {
  padding: 0;
  left: 360px;
  bottom: 0px;
}
.el-tabs >>> .el-tabs__content {
  padding-bottom: 40px;
  padding-left: 20px;
  padding-top: 15px;
  padding-right: 20px;
}
.el-row {
  position: static;
}
.avatar-uploader-icon {
  width: 200px;
  height: 200px;
}
.el-tab-pane .avatar-uploader {
  width: 200px;
  height: 200px;
  position: relative;
  overflow: hidden;
  margin-left: calc(50% - 100px);
  margin-bottom: 20px;
}
.avatar-uploader-have {
  cursor: default;
  margin-left: calc(50% - 100px);
  margin-bottom: 20px;
}
.avatar-edit {
  position: absolute;
  right: 11px;
  top: 11px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  /* visibility: hidden; */
}
/* .avatar-uploader .el-upload:hover .avatar-edit {
  transition: all 2s;
  display: block;
  visibility: visible;
  animation: anBox 1s;
}
@keyframes anBox {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
} */
.avatar {
  width: 200px;
  height: 200px;
  display: block;
}
/* 表单验证 */
.el-form-item {
  margin-bottom: 0;
}
.el-form-item >>> .el-form-item__error {
  color: #f56c6c;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  position: absolute;
  top: 15%;
  left: 0;
}
.input-bottom-err >>> .el-form-item__error {
  left: 10px;
}
.owner-edit-adress td:nth-child(2) {
  padding: 0;
}
.owner-edit-adress td:nth-child(2) .el-input >>> input {
  padding-left: 10px;
}
.owner-edit-adress-input {
  border-bottom: 1px solid #e5e5e5;
}
.owner-edit-adress-noedit {
  padding-left: 11px !important;
}
.paw-petinfo-content-btn {
  position: initial;
  margin-bottom: 0;
}
.paw-petinfo-content-btns {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 30px;
}
.paw-petinfo-content-btn-delete {
  margin-left: 50px;
}
.paw-petinfo-content-btns .el-row {
  display: flex;
  align-content: center;
  justify-content: center;
}
.paw-petinfo-content-btn-save {
  margin-left: 50px;
}

.pw-petinfo-weight-select >>> input {
  padding: 11px 20px;
  background-color: #f7f8f8;
}
.pw-petinfo-weight-select {
  width: 200px;
  border-left: 1px solid #e2e2e2;
}
.pw-petinfo-weight-input {
  width: calc(100% - 200px);
}
.pw-editpetinfo-birthday {
  padding-left: 0 !important;
  background-color: #f7f8f8;
}
.pw-editpetinfo-birthday >>> div {
  width: 100%;
}
.pw-editpetinfo-birthday >>> span {
  display: none;
}
.pw-editpetinfo-birthday >>> input {
  padding: 8px 10px;
  background-color: #f7f8f8;
  font-family: "Poppins-Regular";
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: #1a1a1a;
  border-right: 1px solid #e2e2e2;
  cursor: pointer;
}
.pw-editpetinfo-birthday >>> .el-select:last-child input {
  border-right: none;
}
.pw-editpetinfo-birthday >>> .el-select .el-input.is-focus .el-input__inner {
  border-color: #e2e2e2 !important;
}
.pw-editpetinfo-birthday >>> .el-select .el-input__inner:focus {
  border-color: #e2e2e2 !important;
}
.pw-info-content >>> .el-tabs__nav.is-top {
  display: flex;
  justify-content: center;
  padding-top: 34px;
  column-gap: 71px;
}

.pw-newedit-ui >>> .el-tabs__header.is-top {
  display: none;
}
.pw-newedit-ui >>> .el-tabs__content {
  padding-top: 20px;
  padding-bottom: 34px;
}
.pw-photo-croppper .pw-photo-croppper-content {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
}
.owner-edit-pad-birthday >>> .pw-petinfo-birthday {
  cursor: pointer;
}
/* 裁剪框样式 */
.cropper-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #000;
}
.cropper-content .cropper-box {
  flex: 1;
  width: 100%;
}
.cropper-content .cropper {
  width: 100vw;
  height: 100vh;
}

.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.cropper-content .show-preview .preview {
  overflow: hidden;
  border: 1px solid #67c23a;
  background: #cccccc;
}
.cropper-content .footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}
.footer-btn .scope-btn {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding-right: 10px;
}
.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.footer-btn .btn svg {
  width: 80px;
  height: 80px;
}
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  margin-right: 10px;
  width: 500px;
  height: 500px;
  position: absolute;
  top: calc(50% - 250px);
  left: calc(50% - 250px);
  margin-right: 0;
  margin-bottom: 0;
  display: flex;
}
.cropper-img-upload svg {
  width: 100px;
  height: 100px;
}
.cropper-img-upload {
  border: 1px;
}
.vue-cropper {
  background-image: none;
}
.upload-btn {
  color: #fff;
}
.upload-btn-cancel {
  width: 100px;
  color: #999999;
  background: #fff;
  padding: 8px;
  position: fixed;
  bottom: calc(50vh - 373px);
  left: calc(50% - 50px);
  text-align: center;
  cursor: pointer;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 125%;
}
.upload-btn-confirm {
  width: 100px;
  background: #ff5349;
  padding: 8px;
  position: fixed;
  bottom: calc(50vh - 318px);
  left: calc(50% - 50px);
  text-align: center;
  cursor: pointer;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 125%;
}
.pw-editpetinfo-avater-uploader {
  width: 200px;
  height: 200px;
  margin: 0 auto 20px;
  position: relative;
}
@media screen and (min-width: 767px) and (max-width: 1069px) {
  /* .el-tabs >>> .el-tabs__nav {
    height: 57px;
  } */

  /* .el-tabs >>> .el-tabs__item:nth-child(1) {
    left: 40px;
    top: 12px;
  }
  .el-tabs >>> .el-tabs__item:nth-child(2) {
    right: 34px;
    top: 12px;
  } */
  table {
    empty-cells: show;
    border-collapse: collapse;
    width: 100%;
  }
  table tr {
    border: 0.5px solid #e5e5e5;
    height: 30px;
  }
  table tr >>> td {
    font-size: 12px;
    line-height: 17px;
  }
  table tr >>> td:nth-child(1) {
    width: 130px;
    padding-left: 10.64px;
  }
  table tr td:nth-child(2) {
    max-width: 280px;
    word-wrap: break-word;
    padding: 0 0 0 10px;
  }
  table tr td:nth-child(2) >>> input {
    font-size: 12px;
  }
  .no-editPetState >>> input {
    width: 100%;
    padding-left: 10px;
  }

  /* .no-editPetState-age-right {
    top: -1px;
    width: calc((100% - 130px) / 2);
  } */
  .no-editPetState-age-right >>> .el-select {
    width: 100%;
  }
  .no-editPetState-age-right >>> input {
    width: 100%;
    padding-left: 10px;
    height: 39px;
    font-size: 12px;
  }
  /* .no-editPetState-age-left >>> input {
    width: 140px;
  }
  .no-editPetState-age-left >>> .el-select {
    width: 50%;
  } */
  .no-editPetState-age div {
    width: 100%;
    border-right: 0.5px solid #e5e5e5;
  }
  table >>> .el-input__suffix {
    right: 8px;
  }
  /* .no-editPetState-age-right >>> .el-input__suffix {
    right: 6px;
  } */
  .owner-edit-pad td {
    height: 49px;
  }
  .owner-edit-pad td >>> input {
    height: 48px;
  }
  .owner-edit-pad-more td {
    height: 98px;
  }
  .owner-edit-pad-more td >>> input {
    height: 48px;
  }
  .owner-edit-pad-message td {
    height: 84px;
  }
  .btn-left {
    left: 84px;
  }
  .btn-right {
    left: 244px;
  }
  .el-tabs >>> .el-tabs__content {
    padding-bottom: 40px;
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
  }

  .pw-info-content >>> .el-tabs__nav.is-top {
    padding-top: 12px;
  }

  .pw-editpetinfo-birthday div.el-select {
    width: calc(100% / 3);
  }
  .pw-editpetinfo-birthday >>> div.el-select .el-input.el-input--suffix {
    width: 100%;
  }
  .pw-petinfo-weight-select {
    width: 100px;
  }
  .pw-petinfo-weight-input {
    width: calc(100% - 100px);
  }
}
</style>